// extracted by mini-css-extract-plugin
export default {"impaired":"ImpairedVersion_impaired__zKYFV","id":"ImpairedVersion_id__Yc8hg"};